var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('div',{ref:"editor",attrs:{"id":"editor"}}),_c('input',{ref:"file_click",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.fileUpload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }